import styled from 'styled-components'

export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 35px;
  height: 20px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 13px;
    height: 13px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`

export const CheckboxUi = styled.input.attrs({
  type: 'checkbox',
})`
  margin: 0;
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 35px;
  cursor: pointer;
  height: 20px;
  &:checked + ${CheckBoxLabel} {
    background: var(--default-blue-color);
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 13px;
      height: 13px;
      margin-left: 19px;
      transition: 0.2s;
    }
  }
`

export const CheckboxWrapperUi = styled.div`
  position: relative;
  display: flex;
`
